/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import config from "../config";
import {
  getProductBrands,
  getProductCatlog,
} from "../services/product.service";
import TextLogo from "../assets/text-logo.png";
import Modal from "./Modal";
import Pagination from "./Pagination";
import { storageUrl } from "../env/env";
import Spin from "./spin/Spin";
import Logos, { otherLogos } from "../assets/company-logo";
import { ShowMessage } from "./snackbar";
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      brands: [],
      selectedPath: "home",
      show: false,
      showBrands: true,
      showProductCatalog: false,
      isMenuOpen: false,
      isProductMenuOpen: false,
      selectedCatelogBrand: null,
      products: { data: [] },
      isCatelogloading: false,
    };
  }
  componentDidMount() {
    getProductBrands().then(({ data }) => {
      this.setState(
        {
          brands: data.data,
        },
        () => {
          localStorage.setItem("brands", JSON.stringify(this.state.brands));
        }
      );
    });
  }

  componentDidUpdate(oldProps) {
    if (this.props.location?.state?.brand !== oldProps.location?.state?.brand) {
      this.setState({
        selectedPath: this.props.location.state?.brand?.toUpperCase(),
      });
    }
  }
  setShow = (show) => {
    this.setState({ show });
  };

  fetchProducts = (page, filters = {}) => {
    this.setState(
      {
        isCatelogloading: true,
        filters,
      },
      () => {
        getProductCatlog({ page }, { ...filters })
          .then((resp) => {
            console.log(
              "hello",
              resp.data.data,
              resp?.data?.data?.data?.length
            );
            if (!resp?.data?.data?.data?.length) {
              ShowMessage("No Data Found");
            }
            this.setState({
              isCatelogloading: false,
              products: resp.data.data,
            });
          })
          .catch((err) => {
            this.setState({
              isCatelogloading: false,
              products: [],
            });
          });
      }
    );
  };
  onPageChange = (page) => {
    this.setState({ pageNo: page + 1 });
    const { filters } = this.state;
    this.fetchProducts(page + 1, filters ?? {});
  };
  render() {
    const { brands, show, isProductMenuOpen } = this.state;
    let selectedPath = this.props.location.pathname;
    return (
      <>
        <div className="container_12">
          <div id="top">
            <div className="grid_3">
              <div className="phone_top">
                <span>Call Us {config.phoneNo}</span>
              </div>
            </div>
            <div className="grid_6">
              <div className="welcome">
                {/* Welcome visitor you can <a href="/login.html">login</a> or <a href="/login.html">create an account</a>. */}
              </div>
            </div>
            <div className="grid_3">
              <div className="mail">
                <span>Mail Us {config.mail}</span>
              </div>
            </div>
          </div>
          <div className="clear" />
          <header id="branding">
            <div className="grid_2" id="logoId">
              <hgroup>
                <h1 id="site_logo">
                  <a href="/">
                    <img
                      width={132}
                      height={56}
                      src={`${process.env.PUBLIC_URL}/images/logo.png`}
                      alt="N S Solution"
                    />
                  </a>
                </h1>
                <h2 id="site_description">Powered by your Trust</h2>
              </hgroup>
            </div>
            <div
              className="grid_3"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: 70,
              }}
              id="textlogoId"
            >
              <img
                src={TextLogo}
                alt="N S Solution"
                width={526}
                height={110}
                fetchpriority="high"
                decoding="async"
                style={{ width: window.innerWidth < 600 ? "80%" : "120%", height: "auto" }}
              />
            </div>
            <div
              className="grid_7"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: window.innerWidth < 600 ? "center" : "flex-end",
                height: 70,
              }}
            >
              {/* <button
                style={{ width: 100 }}
                onClick={(e) => this.props.history.push("/inquiry")}
              >
                Inquiry
              </button> */}
              {/* <nav className="private" style={{ margin: "0 10px" }}>
                <ul>
                  <li className="curent">
                    <Link to="/inquiry">Inquiry</Link>
                  </li>
                </ul>
              </nav> */}
              {/* <nav className="private" style={{ margin: "0 10px" }}>
                <ul>
                  <li
                    className="curent"
                    style={{
                      border: "1px blue solid",
                      borderRadius: 8,
                      color: "blue",
                    }}
                  >
                    <Link to="/compare">Compare Products</Link>
                  </li>
                </ul>
              </nav> */}
              <button
                style={{
                  width: 120,
                  margin: "0 10px",
                  border: "1px #3d4095 solid",
                  color: "#fff",
                  backgroundColor: "#3d4095",
                }}
                onClick={(e) => this.props.history.push("/compare")}
              >
                Compare Products
              </button>
              <button
                style={{ width: 100 }}
                onClick={(e) => this.props.history.push("/place-order")}
              >
                Place Order
              </button>
            </div>
          </header>
        </div>
        <div className="clear" />
        <div id="block_nav_primary">
          <div className="container_12">
            <div className="grid_12">
              <nav className="primary">
                <a className={`menu-select`} href="/">
                  Brands
                </a>
                <ul>
                  <li className={selectedPath === "/" ? "curent" : ""}>
                    <a href="/">Home</a>
                  </li>
                  <li
                    className={`${
                      selectedPath.includes("/catelog") &&
                      selectedPath !== "/products"
                        ? "curent"
                        : ""
                    }`}
                  >
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        this.setShow(true);
                      }}
                    >
                      Catelog
                    </a>
                  </li>
                  <li
                    className={`parent ${
                      selectedPath.includes("/products") ? "curent" : ""
                    }`}
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({
                        isProductMenuOpen: !isProductMenuOpen,
                      });
                    }}
                  >
                    <Link to="/products">Products</Link>
                    <ul className="sub">
                      {brands.map((item, index) => (
                        <li
                          key={index}
                          className={
                            selectedPath === item?.brand ? "current" : ""
                          }
                        >
                          <Link
                            to={{
                              pathname: `/products/${item?.brand?.toLowerCase()}`,
                              state: { brand: item?.brand },
                            }}
                          >
                            {item.brand}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </li>
                  <li className={selectedPath === "/inquiry" ? "curent" : ""}>
                    <Link to="/inquiry">Inquiry</Link>
                  </li>
                  <li className={selectedPath === "/about-us" ? "curent" : ""}>
                    <Link to="/about-us">About Us</Link>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
        <div className="clear" />
        <Modal
          titleStyle={{ color: "white" }}
          title={`Catalog`}
          onClose={() => {
            this.setShow(false);
            this.setState({ products: { data: [] } });
          }}
          show={show}
        >
          <Spin loading={this.state?.isCatelogloading}>
            {!this.state.products?.data?.length ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                }}
              >
                {brands?.map((item) => {
                  const logos = Object.keys({ ...Logos, ...otherLogos });
                  let imgUrl = { ...Logos, ...otherLogos }[
                    logos.find((i) =>
                      i?.toLowerCase()?.includes(item?.brand?.toLowerCase())
                    )
                  ];
                  return (
                    <div
                      key={item?.brand}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                        width: 150,
                        height: 200,
                        border: "1px solid",
                        marginBottom: 10,
                        cursor: "pointer",
                      }}
                      onClick={(e) => {
                        this.fetchProducts(1, {
                          brand: item.brand,
                        });
                      }}
                    >
                      {!!imgUrl ? (
                        <div
                          style={{
                            width: "95%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            src={imgUrl}
                            alt=""
                            style={{
                              width: "inherit",
                              height: "inherit",
                              objectFit: "contain",
                            }}
                          />
                        </div>
                      ) : (
                        <h3 style={{ color: "red", textAlign: "center" }}>
                          {item?.brand}
                        </h3>
                      )}
                    </div>
                  );
                })}
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "column",
                }}
              >
                <h5
                  className="modal-title"
                  style={{
                    fontFamily: "sans-serif",
                    cursor: "pointer",
                  }}
                  onClick={(e) => {
                    this.setState({ products: { data: [] } });
                  }}
                >
                  Go Back
                </h5>
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "center",
                  }}
                >
                  <h3>{this.state?.filters?.brand}</h3>
                </div>
                <table class="" style={{ maxHeight: 100 }}>
                  <thead>
                    <tr>
                      <th style={{ color: "blue" }}>
                        <b>Name</b>
                      </th>
                      <th style={{ color: "blue" }}>
                        <b>Presure Rate</b>
                      </th>
                      <th style={{ color: "blue" }}>
                        <b>Catelog Link</b>
                      </th>
                    </tr>
                  </thead>
                  {this.state?.products?.data
                    // ?.filter(
                    //   (value, index, self) =>
                    //     index ===
                    //     self.findIndex(
                    //       (t) =>
                    //         t.presure_rate === value.presure_rate &&
                    //         t.name === value.name
                    //     )
                    // )
                    ?.map((data, index) => (
                      <tr key={index}>
                        <td style={{ color: "blue" }}>{data.name}</td>
                        <td style={{ color: "blue" }}>{data.presure_rate}</td>
                        <td style={{ color: "blue" }}>
                          <a
                            href={`${storageUrl}${data.pdf_url}`}
                            target="_blank"
                            rel="noreferrer"
                            title="Download PDF"
                          >
                            link
                          </a>
                        </td>
                      </tr>
                    ))}
                </table>
                <Pagination
                  {...{
                    totalRow: this.state?.products.total,
                    perPage: this.state?.products.per_page,
                    currentPage: this.state?.products.current_page,
                    onPageChange: this.onPageChange,
                  }}
                />
              </div>
            )}
          </Spin>
        </Modal>
      </>
    );
  }
}

export default withRouter(Header);
